/** Human-readable problems with the parent links of a full room list (empty = valid). */
export function roomParentIssues(rooms) {
    const byId = new Map(rooms.map((r) => [r.id, r]));
    const out = [];
    for (const r of rooms) {
        if (!r.parentId)
            continue;
        const p = byId.get(r.parentId);
        if (r.parentId === r.id)
            out.push(`${r.id}: a room can't be part of itself`);
        else if (!p)
            out.push(`${r.id}: unknown parent room ${r.parentId}`);
        else if ((p.floorId ?? null) !== (r.floorId ?? null))
            out.push(`${r.id}: parent ${p.id} is on a different floor`);
        else if (p.parentId)
            out.push(`${r.id}: parent ${p.id} is itself part of ${p.parentId} (one level only)`);
    }
    return out;
}
/** child id → parent id, only for links that satisfy every rule. */
export function effectiveParents(rooms) {
    const byId = new Map(rooms.map((r) => [r.id, r]));
    const out = new Map();
    for (const r of rooms) {
        if (!r.parentId || r.parentId === r.id)
            continue;
        const p = byId.get(r.parentId);
        if (!p || p.parentId || (p.floorId ?? null) !== (r.floorId ?? null))
            continue;
        out.set(r.id, p.id);
    }
    return out;
}
/** Same list with invalid parent links removed (parentId deleted). Identity-preserving when nothing changes. */
export function withValidParents(rooms) {
    const ok = effectiveParents(rooms);
    if (rooms.every((r) => !r.parentId || ok.get(r.id) === r.parentId))
        return rooms;
    return rooms.map((r) => {
        if (!r.parentId || ok.get(r.id) === r.parentId)
            return r;
        const { parentId: _drop, ...rest } = r;
        return rest;
    });
}
const words = (s) => s.trim().split(/\s+/).filter(Boolean);
/** `name` without the words it shares at the start with `other` ("Master Ensuite" vs "Master Bedroom" → "Ensuite"). */
function stripSharedPrefix(name, other) {
    const a = words(name);
    const b = words(other);
    let i = 0;
    while (i < a.length && i < b.length && a[i].toLowerCase() === b[i].toLowerCase())
        i++;
    return a.slice(i).join(' ');
}
const KIND_LABEL = {
    bedroom: 'Bedroom', bathroom: 'Bathroom', living: 'Room', kitchen: 'Kitchen', utility: 'Utility',
};
/** Tab label for a child space: its name with the parent's prefix stripped ("Ensuite"). */
export function childSpaceLabel(child, parent) {
    return stripSharedPrefix(child.name, parent.name) || child.name;
}
/** Tab label for the parent space itself: "Bedroom" for a bedroom, else its prefix-stripped name. */
export function parentSpaceLabel(parent, children) {
    if (parent.kind === 'bedroom')
        return 'Bedroom';
    const first = children[0];
    return (first && stripSharedPrefix(parent.name, first.name)) || KIND_LABEL[parent.kind] || parent.name;
}
//# sourceMappingURL=rooms.js.map